import { useEffect, useState } from "react"
import CompaniesPageView from "./CompaniesPageView"
import AddCompanyModal from "../../components/construction/AddCompanyModal"
import { ManagementCompany } from "../../Interfaces"

const seed: ManagementCompany[] = [
  { id: 1, name: "Valley Builders", code: "VAL" },
  { id: 2, name: "Pacific Framing", code: "PFR" },
  { id: 3, name: "Oak Electric", code: "OAK" },
]

/**
 * Unauthenticated fixture for Paula’s Companies / Add company layout.
 * /preview/companies?product=construction
 */
export default function CompaniesPreview() {
  const params = new URLSearchParams(window.location.search)
  const empty = params.get("empty") === "1"
  const [companies, setCompanies] = useState(empty ? [] : seed)
  const [open, setOpen] = useState(params.get("modal") === "1")

  useEffect(() => {
    document.documentElement.classList.add("construction-walk")
  }, [])

  return (
    <div className="min-h-screen p-4 md:p-8 bg-secondary-extra-light">
      <CompaniesPageView
        companies={companies}
        onAdd={() => setOpen(true)}
        onSelect={() => undefined}
      />
      <AddCompanyModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onCreated={(company) => setCompanies((current) => [company, ...current])}
      />
    </div>
  )
}
